import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/Rx';

import { StorageService } from './storage.service';
import { ConfigService } from './config.service';
import { SessionService } from './session.service';
import { Guard } from './guard.service';
import { DOCUMENT } from '@angular/platform-browser';
import { OktaService } from './okta.service';
import { timer } from 'rxjs/observable/timer';
import { map } from 'rxjs/operator/map';

@Injectable()
export class AuthService {
    private isAuthenticated: boolean;
    private isAuthenticatedObserver: Subject<boolean> = new BehaviorSubject<boolean>(this.isLoggedIn());
    public isAuthenticated$ = this.isAuthenticatedObserver.asObservable();

    private intervalSessionCheckInMs: number = 5000;

    constructor(
        private http: Http,
        private storageService: StorageService,
        private configService: ConfigService,
        private sessionService: SessionService,
        private guard: Guard,
        private oktaService: OktaService,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.isAuthenticated$.subscribe(
            (data: any) => {
                this.isAuthenticated = data;
            }
        );
    }

    listenForSessionChange(): Observable<any> {
        return timer(0, this.intervalSessionCheckInMs).map(async () => {
              const skipRoute = window.location.pathname.startsWith('/login/callback')
              const oktaIsAuthenticated = await this.oktaService.client.isAuthenticated();
              const activeCookieSession = this.oktaService.checkForActiveSession();
              const existingOktaToken = this.oktaService.checkForExistingOktaToken();
              if (!skipRoute) {
                if (!oktaIsAuthenticated) {
                  // If cookie is present, redirect to okta
                  // If cookie is not present, but okta tokens exist, sign out
                  if (activeCookieSession) {
                    await this.oktaService.oktaSignInWithRedirect()
                  } else if (existingOktaToken) { // In case okta token exists still in the local storage, Navigate to Logout
                    this.logout();
                  }
                } else {
                  await this.oktaService.checkForSessionMismatch();
                }
              }
      
              if (oktaIsAuthenticated && !activeCookieSession) {
                this.logout();
              }
      
              return;
        })
    }

    setSession() {
        const userDetails = this.sessionService.getUserDetails()
        this.sessionService.setUserDetails(userDetails);
        this.fetchAccountFeaturesDetails(this.sessionService.getUserDomain())
            .subscribe( body => {
                userDetails['viewPermissions'] = body.data && body.data.features ? body.data.features : null;
                this.sessionService.setUserDetails(userDetails);
                console.log(userDetails);
                this.guard.refreshPermissions();
                this.isAuthenticatedObserver.next(true);
                },
                error1 => {
                    this.guard.refreshPermissions();
                    this.isAuthenticatedObserver.next(true);
                }
            );
    }

    async logout(): Promise<void> {
        const baseUrl = new URL(window.location.href);
        const postLogoutRedirectUri = `${baseUrl.origin}/logout`;
        try {
          await this.oktaService.client.signOut({
            postLogoutRedirectUri,
          });
        } catch (error) {
          console.error(error);
        }
      }

    login(redirect?: string, switchAccount?: boolean) {
        this.document.location.replace(`${window.location.origin}/login`);
    }

    getJwtClaims(token) {
        if (!token)
            return null;
        var base64 = token.split('.')[1];
        if (base64) {
            var jwtClaims = void 0;
            try {
                jwtClaims = JSON.parse(atob(base64));
                return jwtClaims;
            }
            catch (err) {
                // Malformed JWT
                return null;
            }
        }
        return null;
    }

    isLoggedIn() {
        const ots = this.storageService.get('okta-token-storage');
        return ots && ots.accessToken && ots.accessToken.accessToken;
    }

    tokensExist(): boolean {
        return this.isLoggedIn()
    }

    fetchAccountFeaturesDetails(domain: String) {
        let url = this.configService.get('server').sahara + this.configService.get('endpoints').sahara.accountFeatures.details.api
            + '/' + domain;
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.sessionService.getToken()
        });

        let options = {
            headers: headers
        };

        let requestOptions = new RequestOptions(options);

        return Observable.defer(() => {
            return this.http.get(url, requestOptions)
                .map(this.extractData.bind(this))
                .catch(err => Observable.throw(err));
        });
    }

    private extractData(res: Response) {
        return res.json();
    }
    
    getDomainData(domainUrl: string): Observable<any> {
        let headers = new Headers({
            'Content-Type': 'application/json',
        });

        let options = {
            headers: headers
        };

        let requestOptions = new RequestOptions(options);

        return Observable.defer(() => {
            return this.http.get(domainUrl, requestOptions)
                .map(this.extractData.bind(this))
                .catch(err => Observable.throw(err));
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/auth.service.ts